import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import {
    Box,
    Container,
    TextField,
    Typography,
    AppBar,
    Toolbar,
    IconButton,
    Grid,
    Card,
    CardContent,
    Collapse,
    Chip,
    Switch,
    FormControlLabel,
    Button,
    FormHelperText,
    InputAdornment,
    Popper,
    Paper,
    List,
    ListItem,
    ListItemText,
    ClickAwayListener,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@material-ui/core';
import {
    ArrowBack as ArrowBackIcon,
    ExpandLess as ExpandLessIcon,
    ExpandMore as ExpandMoreIcon,
    KeyboardArrowDown,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSellerLocation, getLocationCountries, getSellerLocations, getSupplierList, getSupplierLocationList, updateSellerLocation, updateSellerConfig } from '../../../store/sellerLocation/sellerLocationActions';
import { getFulfilmentLocations } from '../../../store/fulfilmentLocation/fulfilmentLocationActions';
import { publishMessage } from '../../../store/notification/notificationActions';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    appBar: {
        backgroundColor: 'white',
        color: 'black',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.1)',
    },
    toolbar: {
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    backButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#3f51b5',
        color: 'white',
        '&:hover': {
            backgroundColor: '#34495e',
        },
    },
    title: {
        fontSize: '24px',
        fontWeight: 500,
        color: '#333',
    },
    content: {
        padding: theme.spacing(3),
    },
    sectionCard: {
        marginBottom: theme.spacing(3),
        borderRadius: theme.spacing(1),
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
    },
    sectionHeader: {
        padding: theme.spacing(2, 3),
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
    },
    sectionTitle: {
        fontSize: '18px',
        fontWeight: 500,
        color: '#333',
    },
    sectionContent: {
        padding: theme.spacing(3),
    },

    fieldLabel: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#333',
        textAlign: "left",
        marginBottom: '4px',
        display: 'block',
    },
    textDanger: {
        color: 'red',
        marginLeft: '4px',
    },
    gridItem: {
        marginBottom: theme.spacing(1),
    },
    switchControl: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1),
        margin: theme.spacing(2, 0),
        border: '1px solid #e0e0e0',
        borderRadius: theme.spacing(0.5),
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(4),
        gap: theme.spacing(2),
    },
    backButtonStyle: {
        backgroundColor: 'white',
        color: '#333',
        border: '2px solid #e0e0e0',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1.5, 4),
        fontSize: '16px',
        fontWeight: 500,
        textTransform: 'none',
        minWidth: '150px',
        '&:hover': {
            backgroundColor: '#f8f9fa',
            borderColor: '#ccc',
        },
    },
    createButton: {
        backgroundColor: '#3f51b5',
        color: 'white',
        border: 'none',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1.5, 4),
        fontSize: '16px',
        fontWeight: 500,
        textTransform: 'none',
        minWidth: '200px',
        '&:hover': {
            backgroundColor: '#34495e',
        },
    },
    requiredField: {
        '& label': {
            '&::after': {
                content: '" *"',
                color: 'red',
            },
        },
    },
    searchableSelect: {
        position: 'relative',
        width: '100%',
    },
    searchInput: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            cursor: 'pointer',
            '& fieldset': {
                borderColor: '#e0e0e0',
            },
            '&:hover fieldset': {
                borderColor: '#ccc',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#1976d2',
            },
        },
        '& .MuiInputBase-input': {
            fontSize: '14px',
            padding: '8.5px 14px',
            cursor: 'pointer',
        },
    },
    dropdownPaper: {
        maxHeight: 200,
        overflow: 'auto',
        marginTop: theme.spacing(0.5),
        zIndex: 1300,
    },
    listItem: {
        padding: theme.spacing(1, 2),
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
        '&.selected': {
            backgroundColor: '#e3f2fd',
        },
    },
    multiSelectChips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(0.5),
    },
    chip: {
        height: 24,
        fontSize: '12px',
    },
    // Governance Section Styles
    governanceWidget: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    slaSummaryRow: {
        display: 'flex',
        gap: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: '#f1f5f9',
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    slaSummaryItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    slaSummaryLabel: {
        fontSize: '13px',
        color: '#64748b',
    },
    slaSummaryValue: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1e293b',
    },
    slaRowCard: {
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            borderColor: '#cbd5e1',
        },
    },
    slaRowCardActive: {
        backgroundColor: '#f0f9ff',
        borderColor: '#3b82f6',
        boxShadow: '0 0 0 1px #3b82f6',
    },
    slaRowHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(0),
    },
    slaRowHeaderActive: {
        marginBottom: theme.spacing(2),
    },
    slaRowTitle: {
        fontSize: '15px',
        fontWeight: 500,
        color: '#334155',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    slaRowIcon: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor: '#e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748b',
        fontSize: '14px',
        fontWeight: 600,
    },
    slaRowIconActive: {
        backgroundColor: '#3b82f6',
        color: '#ffffff',
    },
    slaRowInputs: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'flex-start',
        flexWrap: 'wrap',
    },
    slaInputGroup: {
        flex: '1 1 200px',
        minWidth: '180px',
    },
    slaInputLabel: {
        fontSize: '12px',
        fontWeight: 500,
        color: '#64748b',
        marginBottom: theme.spacing(0.5),
        display: 'block',
    },
    warehouseSlaSection: {
        marginTop: theme.spacing(1),
        width: '100%',
    },
    warehouseSlaCard: {
        border: '1px solid #e2e8f0',
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
    },
    warehouseSlaTitle: {
        backgroundColor: '#f8fafc',
        padding: theme.spacing(1.2, 2),
        fontSize: '14px',
        fontWeight: 600,
        color: '#334155',
        borderBottom: '1px solid #e2e8f0',
        textAlign: 'left',
    },
    warehouseSlaTableCell: {
        minWidth: 220,
    },
}));

const SearchableSelect = ({ 
    field, 
    form, 
    options, 
    placeholder, 
    multiple = false,
    getOptionLabel = (option) => option.label || option,
    getOptionValue = (option) => option.value || option,
    isConsolidateWarehouse = false,
    isCountrySelect = false,
    ...props 
}) => {
    const classes = useStyles();
    const { name } = field;
    const { touched, errors, setFieldValue } = form;
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [focused, setFocused] = useState(false);
    
    const hasError = touched[name] && errors[name];
    
    const filteredOptions = options.filter(option => {
        return getOptionLabel(option).toLowerCase().includes(searchTerm.toLowerCase())
    });
    
    const getDisplayValue = () => {
        const fieldValue = field.value;
        
        if (multiple) {
            return '';
        } else {
            if (!fieldValue) return '';
            if (isConsolidateWarehouse) {
            if (Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue[0].name) {
                return fieldValue[0].name;
            }
            return '';
        } else {
            const selectedOption = options.find(option => 
                getOptionValue(option) === fieldValue
            );
            return selectedOption ? getOptionLabel(selectedOption) : '';
        }
    }
    };
    
    const getSelectedChips = () => {
        if (!multiple || !field.value || field.value.length === 0) return [];
        if (isConsolidateWarehouse) {
            return options.filter(option => {
                const optionValue = getOptionValue(option);
                const optionId = Array.isArray(optionValue) && optionValue.length > 0 ? optionValue[0].id : null;
                return field.value.some(val => {
                    const valId = Array.isArray(val) && val.length > 0 ? val[0].id : val;
                    return valId === optionId;
                });
            });
        }
        return options.filter(option => 
            field.value.includes(getOptionValue(option))
        );
    };
    
    const handleInputClick = (event) => {
        if (props.disabled) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        
        // Check if click came from the dropdown icon
        const isIconClick =
          event.currentTarget.tagName === "BUTTON" ||
          event.currentTarget.closest("button");

        let anchorElement = event.currentTarget;

        // If clicking the icon, find the input field for proper positioning
        if (isIconClick) {
          const textField = event.currentTarget.closest(".MuiTextField-root");
          const inputElement = textField?.querySelector("input");
          anchorElement = inputElement || textField || event.currentTarget;

          // For icon clicks, toggle the dropdown
          if (open) {
            handleClose();
            return;
          }
        }
        
        if (!open) {
            setAnchorEl(anchorElement);
            setOpen(true);
            setFocused(true);
            
            if (!multiple) {
                setSearchTerm('');
            }
        }
    };
    
    const handleInputChange = (event) => {
        if (props.disabled) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        setSearchTerm(event.target.value);
        
        if (!open) {
            setAnchorEl(event.currentTarget);
            setOpen(true);
            setFocused(true);
        }
    };
    
    const handleInputFocus = (event) => {
        if (props.disabled) {
            return;
        }
        setFocused(true);
        if (!open) {
            handleInputClick(event);
        }
    };
    
    const handleInputBlur = (event) => {
        setFocused(false);
    };
    
    const handleClose = () => {
        setOpen(false);
        setFocused(false);
        
        if (!multiple) {
            setSearchTerm('');
        } else {
            setSearchTerm('');
        }
    };
    
    const handleOptionClick = (event, option) => {
    event.preventDefault();
    event.stopPropagation();

    const optionValue = getOptionValue(option);
            if (isCountrySelect && option.code) {
            setFieldValue('countryCode', option.code);
        }

    if (multiple) {
        const currentValues = field.value || [];
        
        if (isConsolidateWarehouse) {
            const optionId = Array.isArray(optionValue) && optionValue.length > 0 ? optionValue[0].id : null;
            const isAlreadySelected = currentValues.some(val => {
                const valId = Array.isArray(val) && val.length > 0 ? val[0].id : val;
                return valId === optionId;
            });
            const newValues = isAlreadySelected
                ? currentValues.filter(val => {
                    const valId = Array.isArray(val) && val.length > 0 ? val[0].id : val;
                    return valId !== optionId;
                })
                : [...currentValues, optionValue];
            setFieldValue(name, newValues);
            if (props.onSelectionChange) {
                props.onSelectionChange(newValues);
            }
        } else {
            const newValues = currentValues.includes(optionValue)
                ? currentValues.filter(val => val !== optionValue)
                : [...currentValues, optionValue];
            setFieldValue(name, newValues);
            if (props.onSelectionChange) {
                props.onSelectionChange(newValues);
            }
        }
    } else {
        setFieldValue(name, optionValue);
        if (props.onSelectionChange) {
            props.onSelectionChange(optionValue);
        }
        handleClose();
    }

    setSearchTerm('');
};
    
    const handleChipDelete = (event, optionToDelete) => {
        event.preventDefault();
        event.stopPropagation();
        
        const optionValue = getOptionValue(optionToDelete);
        if (isConsolidateWarehouse) {
            const optionId = Array.isArray(optionValue) && optionValue.length > 0 ? optionValue[0].id : null;
            const newValues = field.value.filter(val => {
                const valId = Array.isArray(val) && val.length > 0 ? val[0].id : val;
                return valId !== optionId;
            });
            setFieldValue(name, newValues);
        } else {
            const newValues = field.value.filter(val => val !== optionValue);
            setFieldValue(name, newValues);
        }
    };
    
    const isSelected = (option) => {
        const optionValue = getOptionValue(option);
       const fieldValue = field.value;
        
        if (multiple && isConsolidateWarehouse) {
            if (!Array.isArray(fieldValue)) return false;
            const optionId = Array.isArray(optionValue) && optionValue.length > 0 ? optionValue[0].id : null;
            return fieldValue.some(val => {
                const valId = Array.isArray(val) && val.length > 0 ? val[0].id : val;
                return valId === optionId;
            });
        } else if (multiple) {
            return Array.isArray(fieldValue) && fieldValue.includes(optionValue);
        } else if (isConsolidateWarehouse) {
            if (Array.isArray(fieldValue) && fieldValue.length > 0) {
                if (Array.isArray(optionValue) && optionValue.length > 0) {
                    return fieldValue[0].id === optionValue[0].id;
                }
            }
            return false;
        } else {
            return fieldValue === optionValue;
        }
    };

    const getInputValue = () => {
        if (open || focused) {
            return searchTerm;
        } else {
            return multiple ? '' : getDisplayValue();
        }
    };

    return (
        <Box className={classes.searchableSelect}>
            <TextField
                {...props}
                variant="outlined"
                size="small"
                placeholder={placeholder}
                value={getInputValue()}
                onChange={handleInputChange}
                onClick={props.disabled ? undefined : handleInputClick}
                onFocus={props.disabled ? undefined : handleInputFocus}
                onBlur={handleInputBlur}
                error={hasError}
                disabled={props.disabled}
                className={classes.searchInput}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={props.disabled ? undefined : handleInputClick}
                                disabled={props.disabled}
                                style={{ padding: 4 }}
                            >
                                <KeyboardArrowDown 
                                    style={{ 
                                        transform: open ? 'rotate(180deg)' : 'none', 
                                        transition: 'transform 0.2s',
                                        fontSize: 20
                                    }} 
                                />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                InputLabelProps={{
                    shrink: false,
                }}
            />
            
            {multiple && field.value && field.value.length > 0 && (
                <Box className={classes.multiSelectChips}>
                    {getSelectedChips().map((option, index) => (
                        <Chip
                            key={index}
                            label={getOptionLabel(option)}
                            onDelete={(event) => handleChipDelete(event, option)}
                            size="small"
                            className={classes.chip}
                        />
                    ))}
                </Box>
            )}
            
            <Popper 
                open={open} 
                anchorEl={anchorEl} 
                style={{ width: anchorEl?.offsetWidth, zIndex: 1300 }}
                placement="bottom-start"
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper className={classes.dropdownPaper}>
                        <List dense>
                            {filteredOptions.length === 0 ? (
                                <ListItem>
                                    <ListItemText primary="No options found" />
                                </ListItem>
                            ) : (
                                filteredOptions.map((option, index) => (
                                    <ListItem
                                        key={index}
                                        button
                                        onClick={(event) => handleOptionClick(event, option)}
                                        className={`${classes.listItem} ${isSelected(option) ? 'selected' : ''}`}
                                    >
                                        {multiple && (
                                            <Checkbox
                                                checked={isSelected(option)}
                                                tabIndex={-1}
                                                disableRipple
                                                style={{ padding: '4px 8px' }}
                                            />
                                        )}
                                        <ListItemText primary={getOptionLabel(option)} />
                                    </ListItem>
                                ))
                            )}
                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
            
            {hasError && (
                <FormHelperText error>{errors[name]}</FormHelperText>
            )}
        </Box>
    );
};

const validationSchema = Yup.object().shape({
    warehouseCountry: Yup.string().required('Country is required'),
    fulfillmentType: Yup.string().required('Fulfillment Type is required'),
    OnboadedByIncreff: Yup.string()
    .required('Onboaded by Increff is required')
    .oneOf(['true', 'false'], 'Invalid selection for Onboaded by Increff'),
    sellerType: Yup.string().when('OnboadedByIncreff', {
        is: 'false',
        then: Yup.string().required('Seller Type is required'),
        otherwise: Yup.string().notRequired(),
    }),
    wareHouseId: Yup.string().when('OnboadedByIncreff', {
        is: "true",
        then: Yup.string().required('Warelocation ID is required'),
        otherwise: Yup.string().notRequired(),
    }),
    warehouseName: Yup.string().required('Warehouse Name is required'),
    warehouseState: Yup.string().required('State is required'),
    area: Yup.string().required('Area is required'),
    city: Yup.string().required('City is required'),
    address: Yup.string().required('Address is required'),
    dailyOrderHandlingCapacity: Yup.number()
        .required('Daily order handling capacity is required')
        .positive('Must be a positive number')
        .integer('Must be a whole number'),
    consolidateWarehouse: Yup.mixed()
        .test('is-selected', 'Consolidate Warehouse is required', value => {
            if (Array.isArray(value) && value.length > 0) {
                const firstItem = value[0];
                if (Array.isArray(firstItem) && firstItem.length > 0) {
                    return !!firstItem[0].id;
                }
                return !!firstItem?.id;
            }
            return !!value;
        })
        .test('warehouse-sla-required', 'SLAs are required for each consolidate warehouse', function (value) {
            const selected = Array.isArray(value) ? value : [];
            if (selected.length === 0) return true;
            const hasInvalid = selected.some((warehouseValue) => {
                const warehouse = Array.isArray(warehouseValue) ? warehouseValue[0] : warehouseValue;
                if (warehouse?.enabled === false) return false;
                const min_sla = warehouse?.min_sla;
                const max_sla = warehouse?.max_sla;
                if (min_sla === '' || min_sla == null || isNaN(Number(min_sla))) return true;
                if (max_sla === '' || max_sla == null || isNaN(Number(max_sla))) return true;
                if (Number(min_sla) < 1 || Number(min_sla) > 20) return true;
                if (Number(max_sla) < 1 || Number(max_sla) > 20) return true;
                return Number(max_sla) < Number(min_sla);
            });
            return !hasInvalid;
        }),
    deliveryType: Yup.mixed().required('Delivery Type is required'),
    governanceSLA: Yup.array()
        .when('governanceFlag', {
            is: true,
            then: Yup.array()
                .min(1, 'At least one SLA type must be selected')
                .test('all-sla-values-required', 'All selected SLA types must have values entered', function(value) {
                    const { acknowledgementSLA, packedSLA, shippedSLA } = this.parent;
                    if (!value || !Array.isArray(value) || value.length === 0) {
                        return true; // Let min validation handle empty array
                    }
                    
                    // Check if all selected SLA types have values
                    const missingSLAs = [];
                    if (value.includes('acknowledgementSLA') && (!acknowledgementSLA || acknowledgementSLA === '')) {
                        missingSLAs.push('Acknowledgement SLA');
                    }
                    if (value.includes('packedSLA') && (!packedSLA || packedSLA === '')) {
                        missingSLAs.push('Packed SLA');
                    }
                    if (value.includes('shippedSLA') && (!shippedSLA || shippedSLA === '')) {
                        missingSLAs.push('Shipped SLA');
                    }
                    
                    if (missingSLAs.length > 0) {
                        return this.createError({ message: `All selected SLA types must have values entered. Missing: ${missingSLAs.join(', ')}` });
                    }
                    return true;
                }),
            otherwise: Yup.array().notRequired(),
        }),
    acknowledgementSLA: Yup.number()
        .when(['governanceFlag', 'governanceSLA'], {
            is: (governanceFlag, governanceSLA) => governanceFlag === true && Array.isArray(governanceSLA) && governanceSLA.includes('acknowledgementSLA'),
            then: Yup.number()
                .typeError('Acknowledgement SLA must be a valid number')
                .required('Acknowledgement SLA is required')
                .positive('Must be a positive number')
                .integer('Must be a whole number'),
            otherwise: Yup.number().notRequired(),
        }),
    packedSLA: Yup.number()
        .when(['governanceFlag', 'governanceSLA'], {
            is: (governanceFlag, governanceSLA) => governanceFlag === true && Array.isArray(governanceSLA) && governanceSLA.includes('packedSLA'),
            then: Yup.number()
                .typeError('Packed SLA must be a valid number')
                .required('Packed SLA is required')
                .positive('Must be a positive number')
                .integer('Must be a whole number')
                .test('packed-greater-than-ack', 'Packed SLA must be greater than Acknowledgement SLA', function(value) {
                    const { acknowledgementSLA, governanceSLA } = this.parent;
                    // Only validate if acknowledgementSLA is also selected
                    if (!governanceSLA || !Array.isArray(governanceSLA) || !governanceSLA.includes('acknowledgementSLA')) {
                        return true;
                    }
                    if (!acknowledgementSLA || !value || isNaN(acknowledgementSLA) || isNaN(value)) {
                        return true;
                    }
                    return Number(value) > Number(acknowledgementSLA);
                }),
            otherwise: Yup.number().notRequired(),
        }),
    shippedSLA: Yup.number()
        .when(['governanceFlag', 'governanceSLA'], {
            is: (governanceFlag, governanceSLA) => governanceFlag === true && Array.isArray(governanceSLA) && governanceSLA.includes('shippedSLA'),
            then: Yup.number()
                .typeError('Shipped SLA must be a valid number')
                .required('Shipped SLA is required')
                .positive('Must be a positive number')
                .integer('Must be a whole number')
                .test('shipped-greater-than-ack', 'Shipped SLA must be greater than Acknowledgement SLA', function(value) {
                    const { acknowledgementSLA, governanceSLA } = this.parent;
                    // Only validate if acknowledgementSLA is also selected
                    if (!governanceSLA || !Array.isArray(governanceSLA) || !governanceSLA.includes('acknowledgementSLA')) {
                        return true;
                    }
                    if (!acknowledgementSLA || !value || isNaN(acknowledgementSLA) || isNaN(value)) {
                        return true;
                    }
                    return Number(value) > Number(acknowledgementSLA);
                })
                .test('shipped-greater-than-packed', 'Shipped SLA must be greater than Packed SLA', function(value) {
                    const { packedSLA, governanceSLA } = this.parent;
                    // Only validate if packedSLA is also selected
                    if (!governanceSLA || !Array.isArray(governanceSLA) || !governanceSLA.includes('packedSLA')) {
                        return true;
                    }
                    if (!packedSLA || !value || isNaN(packedSLA) || isNaN(value)) {
                        return true;
                    }
                    return Number(value) > Number(packedSLA);
                }),
            otherwise: Yup.number().notRequired(),
        }),
    // Configuration section — all optional
    pickupInfoName: Yup.string(),
    configPackedSlaHrs: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    configMaxPackedBuffer: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    configShippedSlaHrs: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    configMaxShippedBuffer: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    maxInwardMidmileHrs: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    maxOutwardMidmileHrs: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
    maxBufferDeliveryHrs: Yup.number().min(0, 'Must be >= 0').nullable().transform((v, o) => o === '' ? null : v),
});

const normalizeConsolidateWarehouses = (value, defaults = {}) => {
    if (!value) return [];
    if (!Array.isArray(value)) return [];
    const normalizeItem = (item) => {
        const base = Array.isArray(item) ? item[0] : item;
        if (!base?.id) return null;
        const weekOff = base.weekOff || base.week_off || defaults.weekOff || [];
        const min_sla = base.min_sla ?? defaults.min_sla ?? '';
        const max_sla = base.max_sla ?? defaults.max_sla ?? '';
        const enabled =
            typeof base.enabled === 'boolean'
                ? base.enabled
                : typeof defaults.enabled === 'boolean'
                    ? defaults.enabled
                    : true;
        return [{
            id: base.id,
            name: base.name,
            weekOff,
            min_sla,
            max_sla,
            enabled,
        }];
    };
    // Each top-level entry is either a wrapped row ([{...}]) or a plain warehouse object ({...})
    return value.map(normalizeItem).filter(Boolean).flat();
};

const getWarehouseIdAndName = (warehouseValue) => {
    const first = Array.isArray(warehouseValue) ? warehouseValue[0] : warehouseValue;
    return {
        warehouseId: first?.id || '',
        warehouseName: first?.name || '',
    };
};

const mergeConsolidateWarehouseData = (warehouses, existingWarehouses = [], defaults = {}) => {
    const selected = normalizeConsolidateWarehouses(warehouses);
    const merged = selected.map((warehouseValue) => {
        const { warehouseId, warehouseName } = getWarehouseIdAndName(warehouseValue);
        const existing = existingWarehouses.find((row) => {
            const existingId = Array.isArray(row) ? row[0]?.id : row?.id;
            return existingId === warehouseId;
        });
        const existingBase = Array.isArray(existing) ? existing[0] : existing;
        const weekOff =
            existingBase?.weekOff || existingBase?.week_off || defaults.weekOff || [];
        const min_sla = existingBase?.min_sla ?? existingBase?.min_sla ?? defaults.min_sla ?? '';
        const max_sla = existingBase?.max_sla ?? existingBase?.max_sla ?? defaults.max_sla ?? '';
        const enabled =
            typeof existingBase?.enabled === 'boolean'
                ? existingBase.enabled
                : typeof defaults.enabled === 'boolean'
                    ? defaults.enabled
                    : true;
        return [{
            id: warehouseId,
            name: warehouseName,
            weekOff,
            min_sla,
            max_sla,
            enabled,
        }];
    });
    return merged;
};

/** API payload: SLA lives only on each consolidate warehouse entry (week_off, min_sla, max_sla). */
const mapConsolidateWarehouseForApi = (rows) => {
    if (!Array.isArray(rows)) return [];
    return rows
        .map((entry) => {
            const w = Array.isArray(entry) ? entry[0] : entry;
            if (!w?.id) return null;
            const disabled = w.enabled === false;
            const minParsed = parseInt(w.min_sla, 10);
            const maxParsed = parseInt(w.max_sla, 10);
            return {
                id: w.id,
                name: w.name,
                week_off: Array.isArray(w.weekOff) ? w.weekOff : [],
                min_sla: disabled
                    ? (Number.isFinite(minParsed) ? minParsed : 0)
                    : minParsed,
                max_sla: disabled
                    ? (Number.isFinite(maxParsed) ? maxParsed : 0)
                    : maxParsed,
                enabled: !disabled,
            };
        })
        .filter(Boolean);
};


export default function CreateSellerLocation() {
    const classes = useStyles();
    const [sellerLocationExpanded, setSellerLocationExpanded] = useState(true);
    const [governanceExpanded, setGovernanceExpanded] = useState(true);
    const [configurationExpanded, setConfigurationExpanded] = useState(true);
    const history = useHistory();
    const { fulfilmentLocations } = useSelector(state => state.fulfilmentLocation);
    const { supplierLists, locationsContries, supplierLocationLists, sellerLocations } = useSelector(state => state.sellerLocation);  

    const dispatch = useDispatch();
    const location = useLocation();
    const isEditMode = location.state?.editMode || false;
    const editData = location.state?.sellerLocationData || null;
    
    // Ref to track if component is mounted (prevents errors when unmounting during async operations)
    const isMountedRef = useRef(true);

    const getInitialValues = () => {
        if (isEditMode && editData) {
            // Build governanceSLA array based on which SLA fields have values
            const governanceSLA = [];
            if (editData.acknowledgement_sla) {
                governanceSLA.push('acknowledgementSLA');
            }
            if (editData.packed_sla) {
                governanceSLA.push('packedSLA');
            }
            if (editData.shipped_sla) {
                governanceSLA.push('shippedSLA');
            }

            const selectedConsolidateWarehouse = normalizeConsolidateWarehouses(
                editData.consolidate_warehouse,
                {
                    weekOff: editData.week_off || [],
                    min_sla: editData.min_sla || '',
                    max_sla: editData.max_sla || '',
                }
            );
            console.log('editData.consolidate_warehouse', editData.consolidate_warehouse);
            console.log('selectedConsolidateWarehouse', selectedConsolidateWarehouse);
            const consolidateWarehouse = mergeConsolidateWarehouseData(
                selectedConsolidateWarehouse,
                editData.consolidate_warehouse || [],
                {
                    weekOff: editData.week_off || [],
                    min_sla: editData.min_sla || '',
                    max_sla: editData.max_sla || '',
                }
            );
            console.log('consolidateWarehouse', consolidateWarehouse);
            return {
                warehouseCountry: editData.country || '',
                countryCode: editData.country_code || '',
                consolidateWarehouse,
                OnboadedByIncreff: editData.onis_styli_registrede_seller.toString() || "false",
                fulfillmentType: editData.fulfillment_type || '',
                wareHouseId: editData.warehouse_id || '',
                warehouseName: editData.warehouse_name || '',
                sellerName: editData.seller_name || '',
                sellerId: editData.seller_id || '',
                warehouseState: editData.warehouse_state || '',
                city: editData.city || '',
                address: editData.address || '',
                area: editData.area || '',
                pinCode: editData.pin_code || '',
                firstMileFlag: editData.firstmile_flag || true,
                dailyOrderHandlingCapacity: editData.daily_order_handling_capacity || '',
                processingCutoffTime: editData.processing_cut_off_time || '',
                latitude: editData.latitude || '',
                longitude: editData.longitude || '',
                deliveryType: editData.delivery_type || '',
                status: editData.status || true,
                isSyncToInventry: editData.is_sync_to_inventry,
                returnFlag: editData.return_flag || false,
                shipFrom: editData.ship_from || '',
                sellerType: editData.seller_type || (editData.onis_styli_registrede_seller === true ? 'wms' : ''),
                governanceFlag: editData.governance_flag || false,
                governanceSLA: governanceSLA,
                acknowledgementSLA: editData.acknowledgement_sla || '',
                packedSLA: editData.packed_sla || '',
                shippedSLA: editData.shipped_sla || '',
                maxAcknowledgementBuffer: editData.max_acknowledgement_buffer || 0,
                maxPackedBuffer: editData.max_packed_buffer || 0,
                maxShippedBuffer: editData.max_shipped_buffer || 0,
                // Store values for seller detail API
                // These should be stored separately in address mapper
                styliWarehouseId: editData.styli_warehouse_id || editData.warehouse_id || '',
                sellerWarehouseId: editData.seller_warehouse_id || '',
                // Configuration section
                pickupInfoName: editData.configuration?.PICKUP_INFO_NAME || '',
                configPackedSlaHrs: editData.configuration?.PACKED_SLA_HRS || '',
                configMaxPackedBuffer: editData.configuration?.MAX_PACKED_BUFFER || '',
                configShippedSlaHrs: editData.configuration?.SHIPPED_SLA_HRS || '',
                configMaxShippedBuffer: editData.configuration?.MAX_SHIPPED_BUFFER || '',
                maxInwardMidmileHrs: editData.configuration?.MAX_INWARD_MIDMILE_HRS || '',
                maxOutwardMidmileHrs: editData.configuration?.MAX_OUTWARD_MIDMILE_HRS || '',
                maxBufferDeliveryHrs: editData.configuration?.MAX_BUFFER_DELIVERY_HRS || '',
            };
        }
        return {
            warehouseCountry: '',
            countryCode: '',
            consolidateWarehouse: [],
            OnboadedByIncreff: "false",
            fulfillmentType: '',
            wareHouseId: '',
            warehouseName: '',
            sellerName: '',
            sellerId: '',
            warehouseState: '',
            city: '',
            address: '',
            area: '',
            pinCode: '',
            firstMileFlag: true,
            dailyOrderHandlingCapacity: '',
            processingCutoffTime: '',
            latitude: '',
            longitude: '',
            deliveryType: '',
            status: true,
            isSyncToInventry: true,
            returnFlag: false,
            shipFrom: '',
            sellerType: '',
            governanceFlag: false,
            governanceSLA: [],
            acknowledgementSLA: '',
            packedSLA: '',
            shippedSLA: '',
            maxAcknowledgementBuffer: 0,
            maxPackedBuffer: 0,
            maxShippedBuffer: 0,
            // Store values for seller detail API
            styliWarehouseId: '',
            sellerWarehouseId: '',
            // Configuration section
            pickupInfoName: '',
            configPackedSlaHrs: '',
            configMaxPackedBuffer: '',
            configShippedSlaHrs: '',
            configMaxShippedBuffer: '',
            maxInwardMidmileHrs: '',
            maxOutwardMidmileHrs: '',
            maxBufferDeliveryHrs: '',
        };
    };

const countries = (locationsContries || [])
    .map((item) => ({
        label: item.name,
        value: item.name,
        code: item.code
    }));

    const warehouses = (fulfilmentLocations || [])
        .map(item => ({
            label: item.warehouse_name,
            value: [{ id: item.warehouse_id, name: item.warehouse_name }] || [],
        }));

    const OnboadedIncreff = [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' },
    ];

    const sellerTypes = [
        { label: 'unicommerce', value: 'unicommerce' },
        { label: 'wms', value: 'wms' },
        { label: 'seller central(luna)', value: 'seller_central_luna' },
    ];

    const fulfillmentTypes = [
        { label: 'CrossDock', value: 'CROSS_DOCK' }
    ];

     const deliveryTypes = [
        { label: 'Standard', value: 'Standard' },
    ];

    const sellers = (supplierLists || []).map(item => ({
        label: item?.full_name || 'N/A',
        value: item?.seller_id || '',
    }));

    const sellerLocationLists = (supplierLocationLists || []).map(item => ({
        label: item?.entity_name || 'N/A',
        value: item?.styli_warehouse_id || '',
    }));

    const weekDays = [
        { label: 'Monday', value: 'Monday' },
        { label: 'Tuesday', value: 'Tuesday' },
        { label: 'Wednesday', value: 'Wednesday' },
        { label: 'Thursday', value: 'Thursday' },
        { label: 'Friday', value: 'Friday' },
        { label: 'Saturday', value: 'Saturday' },
        { label: 'Sunday', value: 'Sunday' }
    ];


       const handleSubmit = async (values, { setSubmitting }) => {
        console.log('values', values);
        try {
            const uuid = uuidv4().replace(/-/g, '').toUpperCase();
            const random4 = uuid.substring(0, 4);
            const primaryWarehouseSla = values.consolidateWarehouse?.[0]?.[0] || {};
            const apiPayload = { 
                country: values.warehouseCountry,
                countryCode: values.countryCode,
                consolidateWarehouse: mapConsolidateWarehouseForApi(values.consolidateWarehouse),
                fulfillmentType: values.fulfillmentType,
                onisStylieRegistredeSeller: values.OnboadedByIncreff === "true",
                warehouseId: values.OnboadedByIncreff === "false" && !isEditMode && !editData && !values.wareHouseId ? `M${random4}` : values.wareHouseId,
                warehouseName: values.warehouseName,
                sellerName: supplierLists?.find(item => item.seller_id === values.sellerId)?.full_name || '',
                sellerId: values.sellerId,
                warehouseState: values.warehouseState,
                city: values.city,
                address: values.address,
                area: values.area,
                pinCode: values.pinCode,
                firstmileFlag: values.firstMileFlag,
                dailyOrderHandlingCapacity: parseInt(values.dailyOrderHandlingCapacity),
                processingCutOffTime: values.processingCutoffTime,
                weekOff: primaryWarehouseSla.weekOff || [],
                min_sla: parseInt(primaryWarehouseSla.min_sla) || 0,
                max_sla: parseInt(primaryWarehouseSla.max_sla) || 0,
                latitude: parseFloat(values.latitude),
                longitude: parseFloat(values.longitude),
                deliveryType: values.deliveryType,
                status: true,
                isSyncToInventry: isEditMode ? editData.is_sync_to_inventry : true,
                returnFlag: values.returnFlag,
                shipFrom: values.shipFrom,
                // Governance fields - stored as flat fields
                sellerType: values.sellerType || (values.OnboadedByIncreff === "true" ? "wms" : null),
                governanceFlag: values.governanceFlag || false,
                acknowledgementSla: values.governanceSLA && values.governanceSLA.includes('acknowledgementSLA') ? parseInt(values.acknowledgementSLA) || null : null,
                packedSla: values.governanceSLA && values.governanceSLA.includes('packedSLA') ? parseInt(values.packedSLA) || null : null,
                shippedSla: values.governanceSLA && values.governanceSLA.includes('shippedSLA') ? parseInt(values.shippedSLA) || null : null,
                maxAcknowledgementBuffer: values.governanceSLA && values.governanceSLA.includes('acknowledgementSLA') ? parseInt(values.maxAcknowledgementBuffer) || 0 : 0,
                maxPackedBuffer: values.governanceSLA && values.governanceSLA.includes('packedSLA') ? parseInt(values.maxPackedBuffer) || 0 : 0,
                maxShippedBuffer: values.governanceSLA && values.governanceSLA.includes('shippedSLA') ? parseInt(values.maxShippedBuffer) || 0 : 0,
                // Store warehouse IDs for OMS integration
                styliWarehouseId: values.styliWarehouseId || '',
                sellerWarehouseId: values.sellerWarehouseId || '',
                // Configuration section
                configuration: {
                    PICKUP_INFO_NAME: values.pickupInfoName || null,
                    PACKED_SLA_HRS: values.configPackedSlaHrs !== '' ? parseInt(values.configPackedSlaHrs) : null,
                    MAX_PACKED_BUFFER: values.configMaxPackedBuffer !== '' ? parseInt(values.configMaxPackedBuffer) : null,
                    SHIPPED_SLA_HRS: values.configShippedSlaHrs !== '' ? parseInt(values.configShippedSlaHrs) : null,
                    MAX_SHIPPED_BUFFER: values.configMaxShippedBuffer !== '' ? parseInt(values.configMaxShippedBuffer) : null,
                    MAX_INWARD_MIDMILE_HRS: values.maxInwardMidmileHrs !== '' ? parseInt(values.maxInwardMidmileHrs) : null,
                    MAX_OUTWARD_MIDMILE_HRS: values.maxOutwardMidmileHrs !== '' ? parseInt(values.maxOutwardMidmileHrs) : null,
                    MAX_BUFFER_DELIVERY_HRS: values.maxBufferDeliveryHrs !== '' ? parseInt(values.maxBufferDeliveryHrs) : null,
                },
            };
            console.log('apiPayload', apiPayload);
    
            // Build configuration payload — only include keys that have values
            const configPayload = apiPayload.configuration;
            const hasConfigData = configPayload && Object.values(configPayload).some(v => v !== null && v !== undefined && v !== '');

            // Callback after seller location create/update succeeds
            const handleSellerLocationSuccess = () => {
                // Call OMS seller-config API only when sellerId, sellerWarehouseId and at least one config field are present
                const warehouseId = values.wareHouseId || values.warehouseId;
                console.log("[handleSellerLocationSuccess] sellerId:", values.sellerId, "| sellerWarehouseId:", values.warehouseId, "| hasConfigData:", hasConfigData);
                if (values.sellerId && warehouseId && hasConfigData) {
                    dispatch(updateSellerConfig(values.sellerId, warehouseId, configPayload));
                } else {
                    console.log("[handleSellerLocationSuccess] OMS config API skipped — conditions not met");
                }
                if (isMountedRef.current) {
                    setTimeout(() => {
                        if (isMountedRef.current) {
                            history.push("/location/sellerLocation");
                        }
                    }, 100);
                }
            };

            if (isEditMode && editData) {
                console.log("[handleSubmit] editData →", JSON.stringify(editData, null, 2));
                console.log("[handleSubmit] apiPayload →", JSON.stringify(apiPayload, null, 2));
                dispatch(updateSellerLocation(editData._id, apiPayload, handleSellerLocationSuccess));
            } else {
                dispatch(createSellerLocation(apiPayload, handleSellerLocationSuccess));
            }
            
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleBackSellerLocation = () => {
        history.push("/location/sellerLocation");
    };

    useEffect(() => {
        isMountedRef.current = true;
        
        dispatch(getSellerLocations());
        dispatch(getFulfilmentLocations());
        dispatch(getLocationCountries());
        if (isEditMode && editData?.country) {
            dispatch(getSupplierList(editData.country_code));
        }
        if (isEditMode && editData?.seller_id) {
            dispatch(getSupplierLocationList(editData.seller_id));
        }
        
        // Cleanup function to mark component as unmounted
        return () => {
            isMountedRef.current = false;
        };
    }, [dispatch, isEditMode, editData]);


    return (
        <div className={classes.root}>
            {/* App Bar */}
            <AppBar position="static" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <IconButton onClick={handleBackSellerLocation} className={classes.backButton}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography className={classes.title}>
                        {isEditMode ? 'Edit Seller Location' : 'Seller Location'}
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Container maxWidth="xl" className={classes.content}>
                <Formik
                    initialValues={getInitialValues()}
                    validationSchema={validationSchema}
                    validateOnChange={true}
                    validateOnBlur={true}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, validateField }) => {
                        const currentSlaSummary = values.consolidateWarehouse?.[0]?.[0] || {};
                        console.log('values', values);

                        const handleWarehouseSlaChange = (rowIndex, fieldName) => (event) => {
                            const updatedWarehouses = [...(values.consolidateWarehouse || [])];
                            const current = updatedWarehouses[rowIndex]?.[0] || {};
                            updatedWarehouses[rowIndex] = [{
                                ...current,
                                [fieldName]: event.target.value,
                            }];
                            setFieldValue('consolidateWarehouse', updatedWarehouses);
                        };

                        const handleWarehouseEnabledChange = (rowIndex) => (event) => {
                            const checked = event.target.checked;
                            const list = values.consolidateWarehouse || [];
                            const updatedWarehouses = list.map((entry, idx) => {
                                const current = Array.isArray(entry) ? entry[0] : entry;
                                if (idx === rowIndex) {
                                    return [{ ...current, enabled: checked }];
                                }
                                return entry;
                            });
                            setFieldValue('consolidateWarehouse', updatedWarehouses);
                        };

                        // Custom change handler for Governance SLA fields to trigger validation
                        const handleGovernanceSlaChange = (field) => (event) => {
                            handleChange(event);
                            
                            // Trigger validation for all governance SLA fields after state update
                            setTimeout(() => {
                                validateField('acknowledgementSLA');
                                validateField('packedSLA');
                                validateField('shippedSLA');
                            }, 0);
                        };
                        return <Form>
                            {/* Seller Location Info Section */}
                            <Card className={classes.sectionCard}>
                                <div
                                    className={classes.sectionHeader}
                                    onClick={() => setSellerLocationExpanded(!sellerLocationExpanded)}
                                >
                                    <Typography className={classes.sectionTitle}>
                                        {isEditMode ? 'Edit Seller Location' : 'Seller Location'}
                                    </Typography>
                                    {sellerLocationExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </div>
                                <Collapse in={sellerLocationExpanded}>
                                    <CardContent className={classes.sectionContent}>
                                        <Grid container spacing={3}>
                                            {/* Row 1 */}
                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Country
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="warehouseCountry">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={countries}
                                                            placeholder="Search country..."
                                                            onSelectionChange={(selectedValue) => {
                                                                const selectedCountry = countries.find(
                                                                    (item) => item.value === selectedValue
                                                                );
                                                                dispatch(getSupplierList(selectedCountry ? selectedCountry.code : ''));
                                                                form.setFieldValue('countryCode', selectedCountry ? selectedCountry.code : '');
                                                            }}
                                                            isCountrySelect={true} 
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Fulfillment Type
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="fulfillmentType">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={fulfillmentTypes}
                                                            placeholder="Search type..."
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>

                                              <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Seller Name
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="sellerId">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={sellers}
                                                            placeholder="Search seller..."
                                                            onSelectionChange={(selectedValue) => {
                                                                const selectedSupplier = supplierLists.find(
                                                                    (item) => item.seller_id === selectedValue
                                                                );
                                                                if (selectedSupplier) {
                                                                    form.setFieldValue('sellerId', selectedSupplier.seller_id);
                                                                    form.setFieldValue('sellerName', selectedSupplier.full_name || '');
                                                                dispatch(getSupplierLocationList(selectedSupplier.seller_id));
                                                                }
                                                              }}
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel}`}>
                                                    Ship From
                                                </Typography>
                                                <Field name="shipFrom">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={sellerLocationLists || []}
                                                            placeholder="Ship From"
                                                            onSelectionChange={(selectedValue) => {  
                                                                console.log("[ShipFrom] selectedValue →", selectedValue, "| supplierLocationLists count →", supplierLocationLists?.length);
                                                                if(sellerLocations.some(s => s.ship_from === selectedValue)){
                                                                    dispatch(
                                                                        publishMessage({
                                                                          message: `Seller Location with this ship from already exists`,
                                                                          severity: "error",
                                                                        })
                                                                    );
                                                                    form.setFieldValue('shipFrom', '');
                                                                    return;
                                                                }
                                                                const selectedSellerLocation = supplierLocationLists.find(
                                                                    (item) => item.styli_warehouse_id === selectedValue
                                                                );
                                                                console.log("[ShipFrom] selectedSellerLocation full object →", JSON.stringify(selectedSellerLocation, null, 2));

                                                                if(selectedSellerLocation?.styli_warehouse_id){
                                                                    form.setFieldValue('shipFrom', selectedSellerLocation.styli_warehouse_id);
                                                                    form.setFieldValue('warehouseName', selectedSellerLocation.entity_name);
                                                                    form.setFieldValue('warehouseId', selectedSellerLocation.styli_warehouse_id);
                                                                    form.setFieldValue('wareHouseId', selectedSellerLocation.styli_warehouse_id);
                                                                    form.setFieldValue('warehouseState', selectedSellerLocation.state);
                                                                    form.setFieldValue('city', selectedSellerLocation.city);
                                                                    form.setFieldValue('address', selectedSellerLocation.address);
                                                                    form.setFieldValue('OnboadedByIncreff', "true");
                                                                    // Store values from API response for seller detail API
                                                                    form.setFieldValue('styliWarehouseId', selectedSellerLocation.styli_warehouse_id || '');
                                                                    form.setFieldValue('sellerWarehouseId', selectedSellerLocation.seller_warehouse_id || '');
                                                                }
                                                            }}
                                                            isCountrySelect={false} 
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>
                                            

                                             <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Warehouse Name
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="warehouseName"
                                                    value={values.warehouseName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.warehouseName && !!errors.warehouseName}
                                                    helperText={touched.warehouseName && errors.warehouseName}
                                                    placeholder="Warehouse Name"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                                <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                    <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                        Consolidate warehouse
                                                        <span className={classes.textDanger}>*</span>
                                                    </Typography>
                                                    <Field name="consolidateWarehouse">
                                                        {({ field, form }) => (
                                                            <SearchableSelect
                                                                field={field}
                                                                form={form}
                                                                options={warehouses}
                                                                placeholder="Search warehouse..."
                                                                isConsolidateWarehouse={true}
                                                                multiple={true}
                                                                onSelectionChange={(selectedWarehouses) => {
                                                                    const normalizedWarehouses = normalizeConsolidateWarehouses(
                                                                        selectedWarehouses,
                                                                        { weekOff: [], min_sla: '', max_sla: '', enabled: true }
                                                                    );
                                                                    const mergedWarehouses = mergeConsolidateWarehouseData(
                                                                        normalizedWarehouses,
                                                                        values.consolidateWarehouse
                                                                    );
                                                                    form.setFieldValue('consolidateWarehouse', mergedWarehouses);
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Registered with Styli WMS
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="OnboadedByIncreff">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={OnboadedIncreff}
                                                            placeholder="Search Increff..."
                                                            onSelectionChange={(selectedValue) => {
                                                                if (selectedValue === "true") {
                                                                    form.setFieldValue('sellerType', 'wms');  // Default to wms when registered with Styli WMS
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>

                                        {(isEditMode || values.OnboadedByIncreff === "true" || values.wareHouseId) && (
                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Warehouse ID
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="wareHouseId"
                                                    value={values.wareHouseId}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    disabled={isEditMode}
                                                    size="small"
                                                    placeholder="Warehouse ID"
                                                    error={touched.wareHouseId && !!errors.wareHouseId}
                                                    helperText={touched.wareHouseId && errors.wareHouseId}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>
                                        )}

                                        {values.OnboadedByIncreff === "false" && (
                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Seller Type
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="sellerType">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={sellerTypes}
                                                            placeholder="Search seller type..."
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>
                                        )}

                                            {/* Row 2 */}
                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    State
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="warehouseState"
                                                    value={values.warehouseState}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.warehouseState && !!errors.warehouseState}
                                                    helperText={touched.warehouseState && errors.warehouseState}
                                                    placeholder="State"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    City
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="city"
                                                    value={values.city}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.city && !!errors.city}
                                                    helperText={touched.city && errors.city}
                                                    placeholder="City"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Address
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="address"
                                                    value={values.address}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.address && !!errors.address}
                                                    helperText={touched.address && errors.address}
                                                    placeholder="Address"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Area
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="area"
                                                    value={values.area}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.area && !!errors.area}
                                                    helperText={touched.area && errors.area}
                                                    placeholder="Area"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    PIN Code
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="pinCode"
                                                    value={values.pinCode}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.pinCode && !!errors.pinCode}
                                                    helperText={touched.pinCode && errors.pinCode}
                                                    placeholder="PIN Code"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Daily order handling capacity
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="dailyOrderHandlingCapacity"
                                                    value={values.dailyOrderHandlingCapacity}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    type="number"
                                                    error={touched.dailyOrderHandlingCapacity && !!errors.dailyOrderHandlingCapacity}
                                                    helperText={touched.dailyOrderHandlingCapacity && errors.dailyOrderHandlingCapacity}
                                                    placeholder="Capacity"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            {/* Row 3 */}
                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Processing Cut off Time
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="processingCutoffTime"
                                                    value={values.processingCutoffTime}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    type="time"
                                                    error={touched.processingCutoffTime && !!errors.processingCutoffTime}
                                                    helperText={touched.processingCutoffTime && errors.processingCutoffTime}
                                                    fullWidth
                                                    InputLabelProps={{ shrink: false }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Latitude
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="latitude"
                                                    value={values.latitude}
                                                    type="number"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.latitude && !!errors.latitude}
                                                    helperText={touched.latitude && errors.latitude}
                                                    placeholder="Latitude"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Longitude
                                                </Typography>
                                                <Field
                                                    as={TextField}
                                                    name="longitude"
                                                    value={values.longitude}
                                                    type="number"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    error={touched.longitude && !!errors.longitude}
                                                    helperText={touched.longitude && errors.longitude}
                                                    placeholder="Longitude"
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Typography className={`${classes.fieldLabel} ${classes.requiredField}`}>
                                                    Delivery Type
                                                    <span className={classes.textDanger}>*</span>
                                                </Typography>
                                                <Field name="deliveryType">
                                                    {({ field, form }) => (
                                                        <SearchableSelect
                                                            field={field}
                                                            form={form}
                                                            options={deliveryTypes}
                                                            placeholder="Search type..."
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Box className={classes.switchControl}>
                                                    <Typography variant="body2">First mile flag</Typography>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={values.firstMileFlag}
                                                                onChange={(e) => setFieldValue('firstMileFlag', e.target.checked)}
                                                                color="primary"
                                                            />
                                                        }
                                                        label={values.firstMileFlag ? "true" : "false"}
                                                        disabled
                                                        labelPlacement="end"
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6} lg={3} md={2.4} className={classes.gridItem}>
                                                <Box className={classes.switchControl}>
                                                    <Typography variant="body2">Return Flag</Typography>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={values.returnFlag}
                                                                onChange={(e) => setFieldValue('returnFlag', e.target.checked)}
                                                                color="primary"
                                                            />
                                                        }
                                                        label={values.returnFlag ? "Yes" : "No"}
                                                        disabled
                                                        labelPlacement="end"
                                                    />
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Collapse>
                            </Card>

                            {/* Consolidate Warehouse SLA Section */}
                            <Card className={classes.sectionCard}>
                                <div className={classes.sectionHeader}>
                                    <Typography className={classes.sectionTitle}>
                                        Consolidate Warehouse SLA
                                        <span className={classes.textDanger}>*</span>
                                    </Typography>
                                </div>
                                <CardContent className={classes.sectionContent}>
                                    <Box className={classes.warehouseSlaSection}>
                                        {(values.consolidateWarehouse || []).map((rowValue, rowIndex) => {
                                            console.log(rowValue);
                                            const row = Array.isArray(rowValue) ? rowValue[0] : rowValue;
                                            return (
                                            <Box key={row?.id || rowIndex} className={classes.warehouseSlaCard}>
                                                <Typography className={classes.warehouseSlaTitle}>
                                                    {row?.name || `Warehouse ${rowIndex + 1}`}
                                                </Typography>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.warehouseSlaTableCell}>Enabled</TableCell>
                                                            <TableCell className={classes.warehouseSlaTableCell}>Week Off</TableCell>
                                                            <TableCell className={classes.warehouseSlaTableCell}>Min SLA</TableCell>
                                                            <TableCell className={classes.warehouseSlaTableCell}>Max SLA</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Switch
                                                                    color="primary"
                                                                    checked={row?.enabled !== false}
                                                                    onChange={handleWarehouseEnabledChange(rowIndex)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Field name={`consolidateWarehouse[${rowIndex}][0].weekOff`}>
                                                                    {({ field, form }) => (
                                                                        <SearchableSelect
                                                                            field={field}
                                                                            form={form}
                                                                            options={weekDays}
                                                                            placeholder="Search days..."
                                                                            multiple={true}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    value={row?.min_sla || ''}
                                                                    onChange={handleWarehouseSlaChange(rowIndex, 'min_sla')}
                                                                    placeholder="Min SLA"
                                                                    fullWidth
                                                                    error={Boolean(errors?.consolidateWarehouse?.[rowIndex]?.[0]?.min_sla)}
                                                                    helperText={errors?.consolidateWarehouse?.[rowIndex]?.[0]?.min_sla}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    value={row?.max_sla || ''}
                                                                    onChange={handleWarehouseSlaChange(rowIndex, 'max_sla')}
                                                                    placeholder="Max SLA"
                                                                    fullWidth
                                                                    error={Boolean(errors?.consolidateWarehouse?.[rowIndex]?.[0]?.max_sla)}
                                                                    helperText={errors?.consolidateWarehouse?.[rowIndex]?.[0]?.max_sla}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            );
                                        })}
                                        {errors.consolidateWarehouse && typeof errors.consolidateWarehouse === 'string' && (
                                            <FormHelperText error>{errors.consolidateWarehouse}</FormHelperText>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>

                            {/* Governance Section */}
                            <Card className={classes.card} style={{ marginTop: 16 }}>
                                <AppBar position="static" className={classes.appBar}>
                                    <Toolbar className={classes.toolbar}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <IconButton
                                                size="small"
                                                onClick={() => setGovernanceExpanded(!governanceExpanded)}
                                                className={classes.collapseButton}
                                            >
                                                {governanceExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                            <Typography className={classes.cardTitle}>Governance</Typography>
                                        </Box>
                                    </Toolbar>
                                </AppBar>
                                <Collapse in={governanceExpanded} timeout="auto">
                                    <CardContent className={classes.cardContent}>
                                        {/* Current SLA Summary */}
                                        <Box className={classes.slaSummaryRow}>
                                            <Box className={classes.slaSummaryItem}>
                                                <Typography className={classes.slaSummaryLabel}>Current Min SLA:</Typography>
                                                <Typography className={classes.slaSummaryValue}>{currentSlaSummary.min_sla || '-'} hrs</Typography>
                                            </Box>
                                            <Box className={classes.slaSummaryItem}>
                                                <Typography className={classes.slaSummaryLabel}>Current Max SLA:</Typography>
                                                <Typography className={classes.slaSummaryValue}>{currentSlaSummary.max_sla || '-'} hrs</Typography>
                                            </Box>
                                        </Box>

                                        {/* Enable Governance Switch */}
                                        <Box mb={3}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={values.governanceFlag}
                                                        onChange={(e) => {
                                                            setFieldValue('governanceFlag', e.target.checked);
                                                            if (!e.target.checked) {
                                                                setFieldValue('governanceSLA', []);
                                                                setFieldValue('acknowledgementSLA', '');
                                                                setFieldValue('packedSLA', '');
                                                                setFieldValue('shippedSLA', '');
                                                                setFieldValue('maxAcknowledgementBuffer', 0);
                                                                setFieldValue('maxPackedBuffer', 0);
                                                                setFieldValue('maxShippedBuffer', 0);
                                                            }
                                                        }}
                                                        color="primary"
                                                    />
                                                }
                                                label={<Typography style={{ fontWeight: 500 }}>Enable Governance SLA</Typography>}
                                                labelPlacement="end"
                                            />
                                        </Box>

                                        {/* SLA Type Cards */}
                                        {values.governanceFlag && (
                                            <Box>
                                                {/* Acknowledgement SLA Card */}
                                                <Box className={`${classes.slaRowCard} ${values.governanceSLA.includes('acknowledgementSLA') ? classes.slaRowCardActive : ''}`}>
                                                    <Box className={`${classes.slaRowHeader} ${values.governanceSLA.includes('acknowledgementSLA') ? classes.slaRowHeaderActive : ''}`}>
                                                        <Box className={classes.slaRowTitle}>
                                                            <Box className={`${classes.slaRowIcon} ${values.governanceSLA.includes('acknowledgementSLA') ? classes.slaRowIconActive : ''}`}>
                                                                A
                                                            </Box>
                                                            <Typography>Acknowledgement SLA</Typography>
                                                        </Box>
                                                        <Switch
                                                            checked={values.governanceSLA.includes('acknowledgementSLA')}
                                                            onChange={(e) => {
                                                                const current = values.governanceSLA || [];
                                                                if (e.target.checked) {
                                                                    setFieldValue('governanceSLA', [...current, 'acknowledgementSLA']);
                                                                } else {
                                                                    setFieldValue('governanceSLA', current.filter(s => s !== 'acknowledgementSLA'));
                                                                    setFieldValue('acknowledgementSLA', '');
                                                                    setFieldValue('maxAcknowledgementBuffer', 0);
                                                                }
                                                            }}
                                                            color="primary"
                                                        />
                                                    </Box>
                                                    {values.governanceSLA.includes('acknowledgementSLA') && (
                                                        <Box className={classes.slaRowInputs}>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>SLA Hours *</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="acknowledgementSLA"
                                                                    value={values.acknowledgementSLA}
                                                                    onChange={handleGovernanceSlaChange('acknowledgementSLA')}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    error={touched.acknowledgementSLA && !!errors.acknowledgementSLA}
                                                                    helperText={touched.acknowledgementSLA && errors.acknowledgementSLA}
                                                                    placeholder="e.g., 24"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>Max Buffer</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="maxAcknowledgementBuffer"
                                                                    value={values.maxAcknowledgementBuffer}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    placeholder="0"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>

                                                {/* Packed SLA Card */}
                                                <Box className={`${classes.slaRowCard} ${values.governanceSLA.includes('packedSLA') ? classes.slaRowCardActive : ''}`}>
                                                    <Box className={`${classes.slaRowHeader} ${values.governanceSLA.includes('packedSLA') ? classes.slaRowHeaderActive : ''}`}>
                                                        <Box className={classes.slaRowTitle}>
                                                            <Box className={`${classes.slaRowIcon} ${values.governanceSLA.includes('packedSLA') ? classes.slaRowIconActive : ''}`}>
                                                                P
                                                            </Box>
                                                            <Typography>Packed SLA</Typography>
                                                        </Box>
                                                        <Switch
                                                            checked={values.governanceSLA.includes('packedSLA')}
                                                            onChange={(e) => {
                                                                const current = values.governanceSLA || [];
                                                                if (e.target.checked) {
                                                                    setFieldValue('governanceSLA', [...current, 'packedSLA']);
                                                                } else {
                                                                    setFieldValue('governanceSLA', current.filter(s => s !== 'packedSLA'));
                                                                    setFieldValue('packedSLA', '');
                                                                    setFieldValue('maxPackedBuffer', 0);
                                                                }
                                                            }}
                                                            color="primary"
                                                        />
                                                    </Box>
                                                    {values.governanceSLA.includes('packedSLA') && (
                                                        <Box className={classes.slaRowInputs}>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>SLA Hours *</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="packedSLA"
                                                                    value={values.packedSLA}
                                                                    onChange={handleGovernanceSlaChange('packedSLA')}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    error={touched.packedSLA && !!errors.packedSLA}
                                                                    helperText={touched.packedSLA && errors.packedSLA}
                                                                    placeholder="e.g., 48"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>Max Buffer</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="maxPackedBuffer"
                                                                    value={values.maxPackedBuffer}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    placeholder="0"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>

                                                {/* Shipped SLA Card */}
                                                <Box className={`${classes.slaRowCard} ${values.governanceSLA.includes('shippedSLA') ? classes.slaRowCardActive : ''}`}>
                                                    <Box className={`${classes.slaRowHeader} ${values.governanceSLA.includes('shippedSLA') ? classes.slaRowHeaderActive : ''}`}>
                                                        <Box className={classes.slaRowTitle}>
                                                            <Box className={`${classes.slaRowIcon} ${values.governanceSLA.includes('shippedSLA') ? classes.slaRowIconActive : ''}`}>
                                                                S
                                                            </Box>
                                                            <Typography>Shipped SLA</Typography>
                                                        </Box>
                                                        <Switch
                                                            checked={values.governanceSLA.includes('shippedSLA')}
                                                            onChange={(e) => {
                                                                const current = values.governanceSLA || [];
                                                                if (e.target.checked) {
                                                                    setFieldValue('governanceSLA', [...current, 'shippedSLA']);
                                                                } else {
                                                                    setFieldValue('governanceSLA', current.filter(s => s !== 'shippedSLA'));
                                                                    setFieldValue('shippedSLA', '');
                                                                    setFieldValue('maxShippedBuffer', 0);
                                                                }
                                                            }}
                                                            color="primary"
                                                        />
                                                    </Box>
                                                    {values.governanceSLA.includes('shippedSLA') && (
                                                        <Box className={classes.slaRowInputs}>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>SLA Hours *</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="shippedSLA"
                                                                    value={values.shippedSLA}
                                                                    onChange={handleGovernanceSlaChange('shippedSLA')}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    error={touched.shippedSLA && !!errors.shippedSLA}
                                                                    helperText={touched.shippedSLA && errors.shippedSLA}
                                                                    placeholder="e.g., 72"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                            <Box className={classes.slaInputGroup}>
                                                                <Typography className={classes.slaInputLabel}>Max Buffer</Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    name="maxShippedBuffer"
                                                                    value={values.maxShippedBuffer}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    type="number"
                                                                    placeholder="0"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        )}
                                    </CardContent>
                                </Collapse>
                            </Card>

                            {/* Configuration Section */}
                            <Card className={classes.card} style={{ marginTop: 16 }}>
                                <AppBar position="static" className={classes.appBar}>
                                    <Toolbar
                                        className={classes.toolbar}
                                        onClick={() => setConfigurationExpanded(!configurationExpanded)}
                                        style={{ cursor: 'pointer', justifyContent: 'space-between' }}
                                    >
                                        <Typography className={classes.cardTitle}>Configuration</Typography>
                                        <IconButton
                                            size="small"
                                            className={classes.collapseButton}
                                            onClick={(e) => { e.stopPropagation(); setConfigurationExpanded(!configurationExpanded); }}
                                        >
                                            {configurationExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    </Toolbar>
                                </AppBar>
                                <Collapse in={configurationExpanded} timeout="auto">
                                    <CardContent className={classes.cardContent}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Pickup Info Name</span>
                                                <TextField
                                                    name="pickupInfoName"
                                                    value={values.pickupInfoName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    placeholder="e.g., Pickup Point A"
                                                    error={touched.pickupInfoName && Boolean(errors.pickupInfoName)}
                                                    helperText={touched.pickupInfoName && errors.pickupInfoName}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Packed SLA (hrs)</span>
                                                <TextField
                                                    name="configPackedSlaHrs"
                                                    value={values.configPackedSlaHrs}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 24"
                                                    error={touched.configPackedSlaHrs && Boolean(errors.configPackedSlaHrs)}
                                                    helperText={touched.configPackedSlaHrs && errors.configPackedSlaHrs}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Max Packed Buffer</span>
                                                <TextField
                                                    name="configMaxPackedBuffer"
                                                    value={values.configMaxPackedBuffer}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 2"
                                                    error={touched.configMaxPackedBuffer && Boolean(errors.configMaxPackedBuffer)}
                                                    helperText={touched.configMaxPackedBuffer && errors.configMaxPackedBuffer}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Shipped SLA (hrs)</span>
                                                <TextField
                                                    name="configShippedSlaHrs"
                                                    value={values.configShippedSlaHrs}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 48"
                                                    error={touched.configShippedSlaHrs && Boolean(errors.configShippedSlaHrs)}
                                                    helperText={touched.configShippedSlaHrs && errors.configShippedSlaHrs}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Max Shipped Buffer</span>
                                                <TextField
                                                    name="configMaxShippedBuffer"
                                                    value={values.configMaxShippedBuffer}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 2"
                                                    error={touched.configMaxShippedBuffer && Boolean(errors.configMaxShippedBuffer)}
                                                    helperText={touched.configMaxShippedBuffer && errors.configMaxShippedBuffer}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Max Inward Midmile (hrs)</span>
                                                <TextField
                                                    name="maxInwardMidmileHrs"
                                                    value={values.maxInwardMidmileHrs}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 12"
                                                    error={touched.maxInwardMidmileHrs && Boolean(errors.maxInwardMidmileHrs)}
                                                    helperText={touched.maxInwardMidmileHrs && errors.maxInwardMidmileHrs}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Max Outward Midmile (hrs)</span>
                                                <TextField
                                                    name="maxOutwardMidmileHrs"
                                                    value={values.maxOutwardMidmileHrs}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 12"
                                                    error={touched.maxOutwardMidmileHrs && Boolean(errors.maxOutwardMidmileHrs)}
                                                    helperText={touched.maxOutwardMidmileHrs && errors.maxOutwardMidmileHrs}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <span className={classes.fieldLabel}>Max Buffer Delivery (hrs)</span>
                                                <TextField
                                                    name="maxBufferDeliveryHrs"
                                                    value={values.maxBufferDeliveryHrs}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    placeholder="e.g., 6"
                                                    error={touched.maxBufferDeliveryHrs && Boolean(errors.maxBufferDeliveryHrs)}
                                                    helperText={touched.maxBufferDeliveryHrs && errors.maxBufferDeliveryHrs}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Collapse>
                            </Card>

                            {/* Action Buttons */}
                            <Box className={classes.buttonContainer}>
                                <Button
                                    variant="outlined"
                                    className={classes.backButtonStyle}
                                    onClick={handleBackSellerLocation}
                                    startIcon={<ArrowBackIcon />}
                                >
                                    Back
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className={classes.createButton}
                                    disabled={isSubmitting}
                                >
                                    {isEditMode ? 'Update Seller Location' : 'Create Seller Location'}
                                </Button>
                            </Box>
                        </Form>
                    }}
                </Formik>
            </Container>
        </div>
    );
}